import React from 'react';
import './App.css';
function App() {
    return (React.createElement("div", { className: "App" },
        "Hello World ",
        React.createElement("br", null),
        "React + TypeScript"));
}
export default App;
